export const paymentAttentionLabels = {
  advanceAtRiskOrOverdue: 'Advance at risk/overdue',
  balanceAtRiskOrOverdue: 'Balance at risk/overdue',
  invoiceOverdue: 'Invoice overdue',
  shipperPaymentOverdue: 'Shipper payment overdue',
  approvalsWaiting: 'Approvals waiting',
} as const;
export type PaymentAttentionReason = keyof typeof paymentAttentionLabels;
export function paymentAttentionReason(value: string | null): PaymentAttentionReason | undefined {
  return value != null && Object.prototype.hasOwnProperty.call(paymentAttentionLabels, value)
    ? (value as PaymentAttentionReason)
    : undefined;
}
